import Component from "@glimmer/component";
import FrlComposerInfo from "../../components/frl-composer-info";

export default class FlexibleRateLimits extends Component {
  static shouldRender(args, { siteSettings }) {
    return (
      siteSettings.flexible_rate_limits_enabled &&
      siteSettings.flexible_rate_limits_stats
    );
  }

  <template>
    {{#unless @outletArgs.model.privateMessage}}
      <FrlComposerInfo @model={{@outletArgs.model}} />
    {{/unless}}
  </template>
}
